<template>

    <!-- Page Sidebar Ends-->
    <div class="container-fluid  bg-primary ">
            <div class="page-title">
              <div class="row">
                <div class="col-12">
                 <img class="img-fluid for_logo" src="../../../assets/images/logo/hcelogo.png"
                                    alt="looginpage">
                </div>
               
              </div>
            </div>
          </div>
          <div class="page-body m-0">
            
        <div class="container-fluid">
            <div class="col-xxl-12">
                
                <div class="">
           

             
             <div class="card p-3 shadow">
             <div class="card-header">
                <h4 class="card-title"> <button class="badge bg-dark" @click="this.$router.go(-1);"><i class="icofont icofont-square-left"></i></button>&nbsp; {{title}}</h4>
            </div> 
        <div class="card-body row">
            
            <div v-show="step==1">
                           <div class="row">
  <!-- Left Column -->
  <div class="col-md-6 mb-3">
    <div class="card p-3 text-center h-100">
      <video ref="video" v-show="!isWorkPermitCaptured" autoplay class="w-100" style="max-height:300px; object-fit:cover;"></video>
      <canvas ref="canvas" style="display: none"></canvas>
      <img 
        v-if="isWorkPermitCaptured" 
        :src="photo" 
        alt="Captured photo" 
        class="img img-thumbnail mt-2"
        style="max-height:300px; object-fit:contain;"
      />
      <div class="d-flex justify-content-between mt-3">
        <button @click="startWebcam" class="btn btn-danger">Reset Camera</button>
        <button @click="captureImage" class="btn btn-primary">Capture Photo</button>
      </div>
    </div>
  </div>

  <!-- Right Column -->
  <div class="col-md-6 mb-3">
    <div class="card p-3 h-100">
      <div class="mb-3">
        <label class="form-label text-danger">Worker Contact Number</label>
        <input
          class="form-control"
          type="number"
          :readonly="VisitorContactReadonly"
          maxlength="10"
          @input="acceptNumber"
          v-model="workpermit.contact"
          placeholder="Type Here..."
          required
        />
      </div>
      <div class="mb-3">
        <label class="form-label text-danger">Worker Name</label>
        <input
          class="form-control"
          type="text"
          :readonly="companyNameReadonly"
          v-model="workpermit.name"
          placeholder="Type Here..."
          required
          v-capitalize
        />
      </div>
      
      
      
      
      
      <div class="mb-3">
        <label class="form-label text-danger">Worker Company Name</label>
        <!--<input-->
        <!--  class="form-control"-->
        <!--  type="text"-->
        <!--  :readonly="companyNameReadonly"-->
        <!--  v-model="workpermit.companyname"-->
        <!--  placeholder="Type Here..."-->
        <!--  required-->
        <!--  v-capitalize-->
        <!--/>-->
        <Autocomplete :items="firmlist" labelField="firmname" valueField="firmname"  :modelValue="query"
                                placeholder="Search Company Here" @select="handleSelect"  @input-change="handleIp" />
                                
      </div>
      <div class="mb-3">
        <label class="form-label text-danger">Worker Address</label>
        <input
          class="form-control"
          type="text"
          :readonly="VisitorAddressReadonly"
          v-model="workpermit.address"
          placeholder="Type Here..."
          required
          v-capitalize
        />
      </div>
      <div class="mb-3">
        <label class="form-label text-danger">Worker Designation</label>
        <input
          class="form-control"
          type="text"
          :readonly="VisitorDesignationReadonly"
          v-model="workpermit.designation"
          placeholder="Type Here..."
          required
          v-capitalize
        />
      </div>
    </div>
  </div>
</div>
 
            </div>
            <div v-show="step==2"> 
                                 <div class="col-12 row ">
                                                  <div class="col-md-6 col-12 position-relative"> 
                                                    <label class="form-label">Staff Name</label>   
                                                       <select id="select2_wp_emplist" class="form-control" v-model="workpermit.empid">
                                                         <option value="0" disabled="" selected="">SELECT STAFF</option>
                                                          <option v-for="emp in emp_list" :key="emp.id" :value="emp.id">
                                                            {{ emp.empname }}
                                                          </option>
                                                        </select>
                                                   
                                                    </div>
                                                      <div class="col-md-6  col-12  position-relative">
                                    <label class="form-label">Worker Purpose</label>
                                    <!--<input class="form-control" type="text" v-model="workpermit.purpose"-->
                                    <!--    placeholder="Type Here..." required=""  v-capitalize>-->
                                     <select v-model="workpermit.purpose" class="form-select">
                                      <option disabled selected>Select Purpose</option>
                                      <option v-for="purpose in purpose_list" :key="purpose" :value="purpose">
                                        {{ purpose }}
                                      </option>
                                    </select>
                                </div>


                                <div class="col-md-12  col-12  position-relative">
                                    <label class="form-label">Remark</label>
                                    <input class="form-control" type="text" v-model="workpermit.remark"
                                        placeholder="Type Here..." required=""  v-capitalize>
                                </div>

                                <div class="col-md-6 col-12  position-relative">
                                    <label class="form-label">From Date</label>
                                    <input class="form-control" type="date" v-model="workpermit.fromdate"  :min="today_minimum_date"
                                        placeholder="Type Here..." required="">
                                </div>


                                <div class="col-md-6 col-12  position-relative">
                                    <label class="form-label">To Date</label>
                                    <input class="form-control" type="date" v-model="workpermit.todate"
                                        placeholder="Type Here..." required="">
                                </div>

                             </div>

            </div>

            

<h3 class="text-danger" v-if="already_exist">{{already_exist}}</h3>
         
    </div>
    
    <div class="card-footer col-12 row">
       <div class="col-12  text-end">
            <button  v-if="step>1"  class="btn alert-light-primary" @click="goto(-1)">Back</button>&nbsp;&nbsp;
            <button  v-if="step<2"  class="btn btn-primary" @click="goto(1)">Next</button>&nbsp;&nbsp;
            <button  v-if="step==2"  class="btn btn-primary" @click="save_workpermit">Submit Data</button>
        </div>
       <!--<div v-else-if="step==2" class="col-6  text-end">-->
       <!--     <button class="btn btn-primary" @click="save_visitor(0)">Create Gatepass</button>-->
       <!-- </div>-->
        <!-- <button class="btn btn-primary" @click="save_visitor(1)">Save And Print</button> -->
    </div>
        <div class="col-12  text-start">
        <button class="btn btn-danger" @click="this.$router.go(-1);">Exit This Page</button>
       </div> 
</div>























              <!-- end---------------------------------------------------------------------------------->











                </div>
            </div>
        </div>
    </div>


<!-- model -->
<!-- Modal Trigger Button -->
  
 <!-- model -->









</template>

<style scoped>
.select2-selection {
    padding: 0.30rem 0.50rem !important;
    border: 1px solid #000000!important;
    font-weight: 600!important;
    height: 35px !important;
}
    .form-control {
    padding: 0.30rem 0.50rem !important;
    border: 1px solid #000000;
    font-weight: 600;
}
.col-md-6{
        margin-bottom: 10px;
}
.pic_img{
        width: 200px;
}
</style>
<script>
// @ is an alias to /src 
import PageTitle from '@/components/PageTitle.vue';
import ModalsPart from '@/components/Modals.vue';
import GatePass from '@/components/GatepassPrint.vue';
// import axios from 'axios';
import axios from "@/plugins/axios";
import QRCode from 'qrcode';

export default {
    name: 'TabGatepass',
    components: {
        PageTitle, ModalsPart, GatePass
    }, mounted() {
        this.getEmps(0);
    },
    watch: {
        //  emp_list() {
        //     this.$nextTick(() => {
        //       if ($('#select2').hasClass('select2-hidden-accessible')) {
        //         $('#select2').select2('destroy');
        //       }
        //       this.initSelect2();
        //     });
        //   }
        },
data() {
        return {
            showModel:false,
            capturedImage: null,

            filteredFirmNames:[],
            filteredNames:[],
            isWorkPermitCaptured:false,
            purpose_list:[],
            firmlist:[],
            query:'',
            
            photo:null,
            emp_list:[],
            already_exist:'',
            isSelect2Initialixed:false,
            step:1,
              workpermit: { "name": '', 'companyname': '', "contact": '', "address": '', 'designation': '', 'fromdate': this.todayDate(), 'todate': this.todayDate(), 'documentpath': '', 'documentid': '', 'purpose': '', 'remark': '', 'expirydate': '','empid':'' },
              title:'Worker Details'

        }
    },
    methods: {
 
            todayDate() {
                var today = new Date();
                var month = today.getMonth() + 1;

                return today.getFullYear() + '-' + ((month < 10) ? '0' + month : month) + '-' + ((today.getDate() < 10) ? '0' + today.getDate() : today.getDate());//today.getDate();;
            },

            acceptNumber() {
                
                if (this.workpermit.contact.toString().length == 10) {
                    // alert(this.visitor.contact.toString().length );
                    var self = this;
                    axios.post('getVisitorContactDetails', { contact_no: self.workpermit.contact }).then(function (response) {
                        if (response.data.is == 1){
                            let visitor = response.data.user;
                            self.workpermit.name= visitor.name;
                            self.workpermit.companyname= visitor.firmname;
                            self.query= visitor.firmname;
                            self.workpermit.address= visitor.address;
                            self.workpermit.designation= visitor.designation;
                        }
                        window.scrollTo(0, 0);
                    });
                }else{
                    if (this.workpermit.contact.toString().length > 10) {
                        this.workpermit.contact = this.workpermit.contact.toString().slice(0, 10)
                    }
                }
            },

         


            
            
            startWebcam() {
                this.isWorkPermitCaptured=false;
            if (navigator.mediaDevices && typeof navigator.mediaDevices.getUserMedia === 'function') {
                navigator.mediaDevices.getUserMedia({ video: true })
                .then((stream) => {
                    const videoElement = this.$refs.video;
                    if (videoElement) {
                    videoElement.srcObject = stream;
                    videoElement.play();
                    } else {
                    console.error("Video element not found.");
                    }
                })
                .catch((err) => {
                    console.error("Error accessing webcam: ", err);
                });
            } else {
                alert("Webcam not supported in this browser.");
                console.error("navigator.mediaDevices or getUserMedia not available.");
            }
            },

        stopWebcam() {
        const video = this.$refs.video;
        const stream = video.srcObject;
        if (stream) {
            const tracks = stream.getTracks();
            tracks.forEach(track => track.stop());
            video.srcObject = null;
        }
        },


    captureImage() {
      const video = this.$refs.video;
      const canvas = this.$refs.canvas;
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      canvas.getContext('2d').drawImage(video, 0, 0);
      this.photo = canvas.toDataURL('image/png');  
      this.workpermit.photo=this.photo;
      this.isWorkPermitCaptured=true; 
      this.stopWebcam();
    },

 

    getUserImage(visitor_row_here) {
  // Check if the visitor has a photo
  if (visitor_row_here && visitor_row_here.capurred_photo) {
    // If photo is in Base64 format, return it directly
    if (visitor_row_here.capurred_photo.startsWith('data:image')) {
      return visitor_row_here.capurred_photo;
    }
    // Otherwise, return file-based image from server path
    return `${this.$hostname}/writable/uploads/visitors/${visitor_row_here.photo}`;
  }else if (visitor_row_here && visitor_row_here.photo){
       return `${this.$hostname}/writable/uploads/visitors/${visitor_row_here.photo}`;
  }

  // If no photo exists, return the default placeholder
  return `${this.$hostname}/writable/visitors/user.png`;
},









  savechanges(){
    this.showModel=false;
  },
 
            hidenameSuggestions() {
            // Add delay so click registers before hiding
            setTimeout(() => {
                this.shownameSuggestions = false;
            }, 100);
            },


// for visitor name-------------------------------------------------------------------------------------------------


 
          getEmps(id=0) {
            var self = this;
            axios.post('getEmployeesForPassCreationTab_V1' ).then(function (response) {
               
                self.emp_list = response.data.employees; 
                self.purpose_list = response.data.purpose_list; 
                self.firmlist = response.data.firmlist; 
               
            }).then(response => {
                  $("#select2_wp_emplist").select2({
                            width: '100%',
                            placeholder: "Search Staff Here...",
                            "language": {
                                "noResults": function () {
                                    return "No Results Found";
                                }
                            },
                            escapeMarkup: function (markup) {
                                return markup;
                            }
                        }).on('change', function (event) {
                         self.workpermit.empid= $(this).val();

                        });
                 self.startWebcam();
            });
        },

        // Converts base64 to Blob (binary)
        // base64ToBlob(base64, contentType = '') {
        //     const byteCharacters = atob(base64);
        //     const byteNumbers = new Array(byteCharacters.length);
        //     for (let i = 0; i < byteCharacters.length; i++) {
        //         byteNumbers[i] = byteCharacters.charCodeAt(i);
        //     }
        //     const byteArray = new Uint8Array(byteNumbers);
        //     return new Blob([byteArray], { type: contentType });
        // },

        base64ToBlob(base64, contentType = '') {
            const byteCharacters = atob(base64);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            return new Blob([byteArray], { type: contentType });
        },

         dataURLtoBlob(dataURL) {
          const byteString = atob(dataURL.split(',')[1]);
          const mimeString = dataURL.split(',')[0].split(':')[1].split(';')[0];
          const ab = new ArrayBuffer(byteString.length);
          const ia = new Uint8Array(ab);
          for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
          }
          return new Blob([ab], { type: mimeString });
        },
        
        //15.05.2025
        // initSelect2() {
        //     const self = this;
        //     $('#select2')
        //       .off('select2:select') // Avoid duplicate handlers
        //       .on('select2:select', function (e) {
        //         const selectedId = e.params.data.id;
        //         self.workpermit.empid= selectedId;
                
        //         // console.log("Selected employee ID:", selectedId);
        //       });
        
        //     $('#select2').select2();
        //   }, 
//03.06.2025
        goto(step){
            
            
            if(this.step==1){
                if(this.workpermit.photo &&this.workpermit.name && this.workpermit.contact && this.workpermit.address){
                        this.step=this.step+step;
                        this.title="Work Details";
                }
                else{
                    this.$swal("Fill Worker Details");
                }        
            }else{
                 this.title="Worker Details";
                 this.step=this.step+step;
            }
        },
            save_workpermit() {
        
                        var self = this;
                        if(!this.photo){
                             self.$swal("Please Capture Photo");
                             return;
                        }
                        const blob = this.dataURLtoBlob(this.photo);
        
        
                        if (self.workpermit.name == '') {
                            self.$swal("Enter name");
                            return;
                        } else if (self.workpermit.contact == '') {
                            self.$swal("Enter Contact");
                            return;
                        }else if (self.workpermit.companyname == '') {
                            self.$swal("Enter Or Select Company Name");
                            return;
                        } else {
        
                            const formData = new FormData();
        
                            
                            formData.append('empid', self.workpermit.empid);
                            formData.append('name', self.workpermit.name);
                            formData.append('workpermit', self.workpermit.workpermit);
                            formData.append('contact', self.workpermit.contact);
                            formData.append('address', self.workpermit.address);
                            formData.append('designation', self.workpermit.designation);
                            formData.append('fromdate', self.workpermit.fromdate);
                            formData.append('todate', self.workpermit.todate);
                            formData.append('companyname', self.workpermit.companyname);
                            formData.append('purpose', self.workpermit.purpose);
                            formData.append('remark', self.workpermit.remark);
                            formData.append('image', blob, 'captured_photo.png');
        
                            // Workpermit documents
                            // this.workpermits.forEach((item, index) => {
                            //     formData.append(`documentid`, item.documentid);
                            //     formData.append(`workpermits[${index}][documentpath]`, item.documentpath);
                            //     formData.append(`workpermits[${index}][expirydate]`, item.expirydate);
                            // });
        
                            axios.post('createworkwisa_TAB', formData)
                                .then(response => {
                                    var msg = response.data.message;
                                        if (response.data.success == 1) { 
                                                    const redirectUrl = window.location.origin + "/wp?q=" + response.data.token;
                                                    console.log("Redirecting to:", redirectUrl);
                                                    window.location.replace(redirectUrl);
                                                }else{
                                                    self.$swal(msg);
                                                }


                                    // if (response.data.success == 1) {
                                    //         window.location.replace(window.location.origin + "/wp?q=" + response.data.token);
                                    //     self.closewebcam();
                                        
                                    //     $("#workpermitAdd").modal("toggle");
                                    //     self.$emit('getworkpermitData', response.data.workpermit);
                                    // }
        
        
        
                                })
                                .catch(error => {
                                    console.log('Error on Authentication: ' + error);
                                });
        
                        }
                    },
                    //05.07.2025
                    handleSelect(selectedItem) {
                        console.log(selectedItem);
                        this.workpermit.companyname = selectedItem.firmname;
                            this.query = selectedItem.firmname;
                    },
                    handleIp(txt) {
                            console.log(txt);
                            this.workpermit.companyname = txt;
                            this.query = txt;
                        },
          
    }
}
</script>
<style scoped>
.modal {
  z-index: 1050;
}
</style>